import React, { useState } from "react"
import PropTypes from "prop-types"
import ModalForm from "../../../components/compounds/modalForm/ModalForm.compunds"
import PrimaryButton from "../../../components/molecules/buttons/PrimaryButton.molecule"
import SecondaryButton from "../../../components/molecules/buttons/SecondaryButton.molecule"
import {
  CLIENT_ACTION_MODAL_MESSAGES,
  CLIENT_TABLE_ROW_ACTIONS,
} from "../../../consts/modules/clients.consts"
import useToast from "../../../hooks/useToast.hook"
import ClientChip from "../../../components/molecules/ClientChip.molecule"
import ProjectChip from "../../../components/molecules/ProjectChip.molecule"
import { ACTION_MODAL_ENTITY_NAME_MAX_CHARS } from "../../../consts/common.const"
import { truncateWithEllipsis } from "../../../utils/strings.utils"

const getClientOrProjectDisplayName = (row) => {
  if (!row?.data) return ""
  if (row.children?.length) {
    return String(row.data.name ?? "").trim()
  }
  const raw = row.data.name
  if (raw == null || raw === "") return ""
  const segments = String(raw).split("-")
  const projectLabel =
    segments.length > 1 ? segments.slice(1).join("-").trim() : ""
  return projectLabel || String(raw).trim()
}

const ActionModal = ({
  row,
  visible,
  setVisible,
  modalAction,
  onFinishedSubmit,
}) => {
  const [submitting, setSubmitting] = useState(false)
  const isClient = Boolean(row?.children)
  const isDeactivate = modalAction === CLIENT_TABLE_ROW_ACTIONS.DEACTIVATE
  const { setErrorMessage } = useToast()

  const getModalMessage = () => {
    if (isDeactivate) {
      return isClient ?
          CLIENT_ACTION_MODAL_MESSAGES.DEACTIVATE_CLIENT
        : CLIENT_ACTION_MODAL_MESSAGES.DEACTIVATE_PROJECT
    }
    return isClient ?
        CLIENT_ACTION_MODAL_MESSAGES.DELETE_CLIENT
      : CLIENT_ACTION_MODAL_MESSAGES.DELETE_PROJECT
  }

  const modalContent = getModalMessage()
  const displayName = getClientOrProjectDisplayName(row)
  const truncatedName = truncateWithEllipsis(
    displayName,
    ACTION_MODAL_ENTITY_NAME_MAX_CHARS
  )
  const titleLabel = modalContent.buildTitle(truncatedName)
  const showFullNameHint =
    displayName && truncatedName !== displayName ? displayName : undefined
  const headerTitle = (
    <span className="inline-flex align-items-center gap-2 flex-wrap">
      <span title={showFullNameHint}>{titleLabel}</span>
      {row?.data &&
        (isClient ?
          <ClientChip clientCode={row.data.code} className="flex-shrink-0" />
        : <ProjectChip
            clientCode={row.data.clientCode}
            projectCode={row.data.code}
            className="flex-shrink-0"
          />)}
    </span>
  )

  const handleSubmit = async () => {
    setSubmitting(true)
    try {
      const response = await modalContent.service(row.id)
      if (!response.success) {
        throw new Error("Error")
      }
      setVisible(false)
      onFinishedSubmit()
    } catch (error) {
      setErrorMessage({
        message: "Ha ocurrido un error al realizar la acción.",
      })
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <ModalForm
      visible={visible}
      setVisible={setVisible}
      headerIconClass="pi pi-info-circle"
      headerTitle={headerTitle}
      footer={
        <div>
          <SecondaryButton
            rounded
            label="Cancelar"
            onClick={() => setVisible(false)}
          />
          <PrimaryButton
            rounded
            icon={`pi ${submitting ? "pi-spin pi-spinner" : "pi-check"}`}
            label={"Aceptar"}
            onClick={handleSubmit}
            disabled={submitting}
          />
        </div>
      }
      service={handleSubmit}
    >
      <span>{modalContent?.description}</span>
    </ModalForm>
  )
}

export default ActionModal

ActionModal.propTypes = {
  row: PropTypes.object,
  visible: PropTypes.bool,
  setVisible: PropTypes.func,
  modalAction: PropTypes.string,
  onFinishedSubmit: PropTypes.func,
}
